// extracted by mini-css-extract-plugin
export default {"device":"iphone_device__YsEFj","screen":"iphone_screen__EB3sg","notch":"iphone_notch__r2PhJ","iframe":"iphone_iframe__Gg7tT"};